import React from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import notificationEventType from '../../../../../../../config/data/notificationTypes';
import styles from './RentalNotFoundModal.module.css';


function RentalNotFoundModal(props) {

  const {
    mode,
    show,
    onHide,
    values,
    handleDelete,
  } = props;

  const targetName = mode === 'notification' ? 'Notification' : 'Activity';
  const bookingData = (values?.bookingData && values.bookingData[0]);
  
  const handleAction = () => {
    if (values) {
      const { id } = values;
      handleDelete(id);
    };
    onHide();
  };

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={styles.modalTitle}
        >
          {values?.message}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        {[
          notificationEventType.RENTAL_NOT_FOUND_TO_CREATE_RESERVATION,
          notificationEventType.RENTAL_NOT_FOUND_TO_UPDATE_RESERVATION,
          notificationEventType.RENTAL_NOT_FOUND_TO_REQUEST_RESERVATION,
          notificationEventType.RENTAL_NOT_FOUND_TO_DELETE_RESERVATION,
        ].includes(values?.type) && (
          <>
            <p>
              We received information from an OTA that references a rental which could not be found in your Beehaz account.
            </p>
            <p>
              The data received may refer to a new reservation, a reservation modification, or a reservation cancellation.
            </p>
            <p>
              This can happen in the following cases:
            </p>
            <p>
              <div style={{display: 'flex'}}>
                <div style={{paddingInline: '20px'}}>-</div><div>A rental previously connected to an OTA was deleted from your Beehaz account, but still exists in the OTA’s system.</div>
              </div>
              <div style={{display: 'flex'}}>
                <div style={{paddingInline: '20px'}}>-</div><div>An error occurred while mapping a rental to the OTA.</div>
              </div>
            </p>
            <p>Information received:</p>
            <p style={{display: 'flex'}}>
              <div style={{paddingLeft: '20px'}}>
                <div>OTA:</div>
                <div>Arrival date:</div>
              </div>
              <div style={{paddingLeft: '70px'}}>
                <div>{bookingData?.ota}</div>
                <div>{moment(bookingData?.arrive).format('DD MMMM YYYY') || 'N/A'}</div>
              </div>
            </p>
            <p>Recommended next steps:</p>
            <p style={{display: 'flex'}}>
              <div style={{paddingInline: '20px'}}>1.</div><div>Check your existing rentals in the OTA’s extranet.</div>
            </p>
            <p style={{display: 'flex'}}>
              <div style={{paddingInline: '20px'}}>2.</div><div>Ensure that all rentals created in the OTA’s platform also exist in your Beehaz account.</div>
            </p>
            <p style={{display: 'flex'}}>
              <div style={{paddingInline: '20px'}}>3.</div><div>Map the rentals in the OTA’s account to their corresponding rentals in Beehaz.</div>
            </p>
            <p style={{display: 'flex'}}>
              <div style={{paddingInline: '20px'}}>4.</div><div>Verify whether there is an existing reservation in the OTA that does not exist in Beehaz, and take the appropriate action.</div>
            </p>
          </>
        )}
        <div className={styles.modalButtonContainer}>
          <button
            onClick={handleClose}
            className={styles.grayButton}
          >
            Close
          </button>
          { mode === 'notification' &&
            <button
              onClick={handleAction}
              className={styles.redButton}
            >
              Delete Notification
            </button>
          }
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RentalNotFoundModal;